import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import { MdDone } from 'react-icons/lib/md';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withAuth } from '../../actions/';
import { fetchBidPkgStatus, fetchBidCheckListStatus, fetchBidPackages, fetchPermissionsByModule } from '../../actions/project_actions';
import { DateField } from './schedule_utils';
import { DateFieldFixedDateBelow } from './date_picker_fixed_dateBelow';

import BidPkgViewForm from './BidPkgViewForm';

class BidPackageNew extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isChecked: false,
            showChecklist: false,
            showSaveBtn: true,
            bidPkgCheckListStatuses: props.selBidPkgCheckListStatuses,
            bidPackage: this.getInitialState(),
            showSavedMsg: false,
        };

        this.getInitialState = this.getInitialState.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSelectChangeLists = this.handleSelectChangeLists.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.submitInitial = this.submitInitial.bind(this);
        this.renderSelectField = this.renderSelectField.bind(this);

        this.renderSelectFieldTable = this.renderSelectFieldTable.bind(this);
    }

    getInitialState() {
        return {
            id: -1,
            statusId: '',
            submittedDate: '',
            approvedDate: '',
            returnedDate: '',
            comment: '',
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let showChecklist = false, showSaveBtn = true;

        this.setState({ bidPkgCheckListStatuses: nextProps.selBidPkgCheckListStatuses });

        if (this.props.bidPackages[0] !== nextProps.bidPackages[0]) {
            showChecklist = true;
            showSaveBtn = false;
            this.setState({ bidPackage: nextProps.bidPackages[0], showChecklist, showSaveBtn });
        }
    }

    UNSAFE_componentWillMount() {
        const { bidPkgCheckListStatuses } = this.props;

        this.props.fetchPermissionsByModule('BidPackage');
        this.props.fetchBidPkgStatus();
        this.props.fetchBidCheckListStatus();
        this.props.fetchBidPackages(this.props.projectId);

        if (bidPkgCheckListStatuses.length > 0)
            this.setState({ bidPkgCheckListStatuses: bidPkgCheckListStatuses });
    }

    getBidPkgStatusOptions() {
        return this.props.bidPkgStatuses.map(bidPkgStatus => {
            return {
                label: bidPkgStatus.statusName,
                value: bidPkgStatus.statusId
            }
        });
    }

    handleSelectChange(field) {
        return (option) => {
            const value = option ? option.value : null;
            const bidPackage = { ...this.state.bidPackage, [field]: value }
            this.setState({ bidPackage });
        }
    }

    handleChange(field) {
        return (e) => {
            const bidPackage = this.state.bidPackage;
            bidPackage[field] = e.target.value;
            this.setState({ bidPackage: bidPackage });
        }
    }

    handleCheckboxChange(event) {
        const bidPackage = this.state.bidPackage;
        bidPackage.rcvdBidPkg = event.target.checked;
        this.setState({ bidPackage });
    }

    handleDateChange(name) {
        return (date) => {
            const bidPackage = this.state.bidPackage;
            bidPackage[name] = date;
            this.setState({ bidPackage: bidPackage });
        }
    }

    handleClick() {
        this.setState({
            showChecklist: !this.state.showChecklist,
            showSaveBtn: false,
        });

        this.submitInitial();
    }

    renderInitialSelectField(label, name) {
        return (
            <div className="controls with-select required">
                <label>{label}</label>
                <Select name={name}
                    value={this.state.bidPackage[name]}
                    options={this.getBidPkgStatusOptions()}
                    onChange={this.handleSelectChange(name)}
                />
            </div>
        );
    }

    handleSelectChangeLists(field) {
        return (option) => {
            const value = option ? option.value : null;
            const bidPkgCheckListStatuses = this.state.bidPkgCheckListStatuses;
            var ind = bidPkgCheckListStatuses.findIndex(c => c.chkListLabelId === field);
            bidPkgCheckListStatuses[ind].chkListStatusId = value;
            this.setState({ bidPkgCheckListStatuses });
        }

    }

    // for checklist dd
    getOptions(chkLstLabels) {
        return chkLstLabels.map(bidPkgCheckListStatus => {
            return {
                label: bidPkgCheckListStatus.chkListStatusName,
                value: bidPkgCheckListStatus.chkListStatusId
            }
        });
    }

    renderSelectField(chkListLabelId) {
        var chkLstLabels = this.props.bidPkgCheckListStatuses.filter(c => c.chkListLabelId === chkListLabelId);
        if (chkLstLabels.length > 0 && this.state.bidPkgCheckListStatuses.length > 0) {
            var ind = this.state.bidPkgCheckListStatuses.findIndex(c => c.chkListLabelId === chkListLabelId);
            var labelName = chkLstLabels[0].chkListLabelName;

            return (

                <div className="controls with-select">
                    <label>{labelName}</label>
                    <Select name={'chkList-' + chkListLabelId}
                        value={this.state.bidPkgCheckListStatuses[ind].chkListStatusId}
                        options={this.getOptions(chkLstLabels)}
                        onChange={this.handleSelectChangeLists(chkListLabelId)}
                    />
                </div>
            );
        }
        else
            return null;
    }

    renderSelectFieldTable(chkListLabelId) {

        var chkLstLabels = this.props.bidPkgCheckListStatuses.filter(c => c.chkListLabelId === chkListLabelId);
        if (chkLstLabels.length > 0 && this.state.bidPkgCheckListStatuses.length > 0) {
            var ind = this.state.bidPkgCheckListStatuses.findIndex(c => c.chkListLabelId === chkListLabelId);

            return (

                <div className="controls with-select">
                    <Select name={'chkList-' + chkListLabelId}
                        value={this.state.bidPkgCheckListStatuses[ind].chkListStatusId}
                        options={this.getOptions(chkLstLabels)}
                        onChange={this.handleSelectChangeLists(chkListLabelId)}
                    />
                </div>
            );
        }
        else
            return null;
    }

    submitInitial() {

        const bidPackage = this.state.bidPackage;
        const projectId = this.props.projectId;
        const bidPkgCheckListStatuses = this.state.bidPkgCheckListStatuses;
        bidPackage.projectId = projectId;
        bidPackage.lkp_BidPkgStatus = null;
        bidPackage.bidPkgCheckLists = bidPkgCheckListStatuses.filter(c => c.chkListStatusId > 0);

        let method = 'post';
        let url = `projects/${projectId}/BidPackage`;

        if (bidPackage.id > 0) {
            method = 'put';
            url = `${url}/${bidPackage.id}`;
        }

        withAuth(
            { method, url, data: bidPackage },
            () => {
                this.props.fetchBidPackages(projectId);

                this.setState({ showSavedMsg: true });
                toast.success('Saved Successfully!');
            },
            this.errorHandler
        )

    }

    render() {
        const { bidPackage, bidPkgCheckListStatuses, showChecklist } = this.state;
        const { canEdit } = this.props.permissionsModule;

        if (bidPackage === undefined) 
            return (<div id="bidPackageEmpty"></div>);

        const classNameComment = 'controls' + (bidPackage.statusId === 2 ? ' required' : '');
        const classNameDateReturned = 'controls date-control' + (bidPackage.statusId === 2 ? ' required' : '');
        const classNameDateApproved = 'controls date-control' + (bidPackage.statusId === 3 ? ' required' : '');

        let checkboxDisabled = false;
        if (bidPackage.rcvdBidPkg !== '' && bidPackage.rcvdBidPkg !== undefined) checkboxDisabled = true;
        else checkboxDisabled = false;

        let canSubmit = false;
        canSubmit = (((bidPackage.statusId !== undefined && bidPackage.statusId !== '' && bidPackage.statusId !== null)
            && (bidPackage.submittedDate !== undefined && bidPackage.submittedDate !== '')
            && (bidPackage.rcvdBidPkg !== false && bidPackage.rcvdBidPkg !== undefined)))
            && (bidPackage.statusId === 2
                ? (bidPackage.comment !== '' && bidPackage.comment !== null && bidPackage.comment !== undefined && bidPackage.returnedDate !== undefined && bidPackage.returnedDate !== '')
                : true)
            && (bidPackage.statusId === 3 ? (bidPackage.approvedDate !== undefined && bidPackage.approvedDate !== '') : true);

        let testSaveBtn = false;
        testSaveBtn = (bidPackage.id === -1);

        return (
            <div id="bidPackage" className="row-wide bid-package">

                <div className="col s12">
                    <h4 className="bar-bottom">A&E Bid packaging review</h4>
                </div>

                {this.state.showSavedMsg &&
                    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={2000}
                        position={'top-center'}
                    />}

                {canEdit
                    ? <div>
                        <div className="col s12">
                            <div className="border-grey">
                                <div className="row inner-box-content">
                                    <div className="md-checkbox label-required-custom">
                                        <input id="bp-received" type="checkbox" onChange={this.handleCheckboxChange} checked={bidPackage.rcvdBidPkg} disabled={checkboxDisabled} />
                                        <label htmlFor="bp-received">I have received Bid Package</label>
                                        <span></span>
                                    </div>
                                </div>

                                {/* {isChecked ? */}
                                <div className="row">

                                    <div className="col l4 m4 s12">
                                        {this.renderInitialSelectField('Bid Package Status', 'statusId')}
                                    </div>

                                    <div className="col l4 m4 s12">
                                        <div className="controls date-control required">
                                            <label>Date submitted</label>

                                            {bidPackage.statusId === 3 &&
                                                <DateFieldFixedDateBelow name="submittedDate"
                                                    value={bidPackage.submittedDate}
                                                    limits={{ dateBelow: bidPackage.approvedDate }}
                                                    onChange={this.handleDateChange('submittedDate')} />}

                                            {bidPackage.statusId === 2 &&
                                                <DateFieldFixedDateBelow name="submittedDate"
                                                    value={bidPackage.submittedDate}
                                                    limits={{ dateBelow: bidPackage.returnedDate }}
                                                    onChange={this.handleDateChange('submittedDate')} />}

                                            {(bidPackage.statusId === 1 || bidPackage.statusId === null || bidPackage.statusId === '' || bidPackage.statusId === undefined) &&
                                                <DateField name="submittedDate"
                                                    value={bidPackage.submittedDate}
                                                    limits={{}}
                                                    onChange={this.handleDateChange('submittedDate')} />}
                                        </div>
                                    </div>

                                    {/* If status is approved  */}
                                    {bidPackage.statusId === 3
                                        ? <div className="col l4 m4 s12">
                                            <div className={classNameDateApproved}>
                                                <label>Date approved</label>
                                                <DateField name="approvedDate"
                                                    value={bidPackage.approvedDate}
                                                    limits={{ dateAbove: bidPackage.submittedDate }}
                                                    onChange={this.handleDateChange('approvedDate')}
                                                />
                                            </div>
                                        </div>
                                        : null}

                                    {/* If status is returned  */}
                                    {bidPackage.statusId === 2
                                        ? <div className="col l4 m4 s12">
                                            <div className={classNameDateReturned}>
                                                <label>Date returned</label>
                                                <DateField name="approvedDate"
                                                    value={bidPackage.returnedDate}
                                                    limits={{ dateAbove: bidPackage.submittedDate }}
                                                    onChange={this.handleDateChange('returnedDate')}
                                                />
                                            </div>
                                        </div>
                                        : null}

                                    <div className="col s12">
                                        <div className={classNameComment}>
                                            <label>Comments</label>
                                            <textarea name="comment" rows="3" id="textarea-custom-bordered-border-1"
                                                onChange={this.handleChange('comment')}
                                                value={bidPackage.comment}
                                            ></textarea>
                                        </div>
                                    </div>

                                    {testSaveBtn && canEdit ?
                                        <div className="col s12">
                                            <div className="controls">
                                                <button id="initialSaveBtn" className="btn-save" onClick={() => this.handleClick()} disabled={!canSubmit}>Save</button>
                                            </div>
                                        </div>
                                        : null}
                                    
                                    {showChecklist && !testSaveBtn && canEdit ?
                                        
                                        <div className="col s12">
                                            <div className="controls">
                                                <button id="saveBtn"  className="btn-save" onClick={this.submitInitial}>Save</button>
                                            </div>
                                        </div> : null
                                    }
                                </div>
                            </div>
                        </div>

                        
                        {/* {showChecklist ?       // // Disable checklist
                            <div id="bidPackageCheckList">

                                <div className="col s12">
                                    <div className="sub-heading">
                                        <h6>Checklist</h6>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <label>Document name</label>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        <label>Required/Not required</label>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        <label>Submitted/Not submitted</label>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        <label>Approved/Returned</label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>Accessibility Form</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(15)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>ACCO Flow CSB Sheet with PIN number</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(13)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>Addendum to General Conditions: word</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(5)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[4].chkListStatusId === 9
                                            ? this.renderSelectFieldTable(6)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>APT E-Pin number (by BP)</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(14)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s12">
                                        <p>Asbestos abatement and/or incidental specifications: pdf</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(9)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[8].chkListStatusId === 17
                                            ? this.renderSelectFieldTable(10)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Bid alternate approval</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(30)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[28].chkListStatusId === 59
                                            ? this.renderSelectFieldTable(45)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">

                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Bid Package Checklist: pdf</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(32)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Bid Submission Form: pdf</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(31)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s12">
                                        <p>Commissioning Agent specifications</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(11)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[10].chkListStatusId === 21
                                            ? this.renderSelectFieldTable(48)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[10].chkListStatusId === 21
                                            ? this.renderSelectFieldTable(12)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>Constructability Sign Off of Drawings</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(18)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>Consultant’s Cost Estimate: excel</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(3)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[2].chkListStatusId === 5
                                            ? this.renderSelectFieldTable(4)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Feasibility Study approval – for New Construction projects</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(22)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[20].chkListStatusId === 43
                                            ? this.renderSelectFieldTable(37)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Federal Contract Documents</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(21)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[19].chkListStatusId === 41
                                            ? this.renderSelectFieldTable(36)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Geotechnical Report</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(20)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[18].chkListStatusId === 39
                                            ? this.renderSelectFieldTable(35)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>MWBE Schedule B (by BP)</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(17)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>MWBE worksheet completed</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(16)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>PQL approval</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(24)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[22].chkListStatusId === 47
                                            ? this.renderSelectFieldTable(39)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Proprietary items approval: signed memo</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(46)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[44].chkListStatusId === 91
                                            ? this.renderSelectFieldTable(47)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Proprietary items justification</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(28)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[26].chkListStatusId === 55
                                            ? this.renderSelectFieldTable(51)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[26].chkListStatusId === 55
                                            ? this.renderSelectFieldTable(43)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Proprietary items list of costs</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(29)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[27].chkListStatusId === 57
                                            ? this.renderSelectFieldTable(52)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[27].chkListStatusId === 57
                                            ? this.renderSelectFieldTable(44)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Special Experience approval</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(27)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[25].chkListStatusId === 53
                                            ? this.renderSelectFieldTable(42)
                                            : null}
                                    </div>
                                    <div className="col l3 m3">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Special Experience Bid Booklet Page (by BP)</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(26)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[24].chkListStatusId === 51
                                            ? this.renderSelectFieldTable(41)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Special Experience Justification</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(25)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[23].chkListStatusId === 49
                                            ? this.renderSelectFieldTable(50)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[23].chkListStatusId === 49
                                            ? this.renderSelectFieldTable(40)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>Specifications: combined pdf</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(1)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[0].chkListStatusId === 1
                                            ? this.renderSelectFieldTable(2)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>Specifications: printed double sided, unbound</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(33)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[31].chkListStatusId === 65
                                            ? this.renderSelectFieldTable(34)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s8">
                                        <p>Table of Contents: word</p>
                                    </div>
                                    <div className="col l3 m3 s4">
                                        <p><MdDone size={20} color="#008000" /></p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(7)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[6].chkListStatusId === 13
                                            ? this.renderSelectFieldTable(8)
                                            : null}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col l3 m3 s6">
                                        <p>Unit Price Schedule</p>
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {this.renderSelectFieldTable(23)}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[21].chkListStatusId === 45
                                            ? this.renderSelectFieldTable(49)
                                            : null}
                                    </div>
                                    <div className="col l3 m3 s6">
                                        {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[21].chkListStatusId === 45
                                            ? this.renderSelectFieldTable(38)
                                            : null}
                                    </div>
                                </div>

                                
                            </div>
                            : null} */}

                    </div>
                    : <div>
                        <BidPkgViewForm bidPackage={bidPackage}
                            bidPkgCheckListStatuses={this.state.bidPkgCheckListStatuses} />
                    </div>}
            </div>
        );
    }
}

BidPackageNew.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    permissionsModule: PropTypes.object.isRequired,
    bidPackages: PropTypes.array.isRequired,
    bidPkgStatuses: PropTypes.array.isRequired,
    bidPkgCheckListStatuses: PropTypes.array.isRequired,
    fetchBidPkgStatus: PropTypes.func.isRequired,
    fetchBidCheckListStatus: PropTypes.func.isRequired,
    fetchBidPackages: PropTypes.func.isRequired
};

function getSelBidPkgStatuses(bidPackages, bidPkgCheckListStatuses) {
    var locList = [];

    var bidPkgCheckListStatusesLoc = [];
    if (bidPkgCheckListStatuses.length > 0) {
        var uniquechkStatuses = [...new Set(bidPkgCheckListStatuses.map(item => item.chkListLabelId))];
        bidPkgCheckListStatusesLoc = uniquechkStatuses.map(c => { return { chkListLabelId: c, chkListStatusId: '' } });
    }

    if (bidPackages.length > 0 && bidPkgCheckListStatusesLoc.length > 0) {
        var selBidPkgCheckLists = bidPackages[0].bidPkgCheckLists;

        locList = bidPkgCheckListStatusesLoc.map(e => {
            var arr = selBidPkgCheckLists.filter(c => c.chkListLabelId === e.chkListLabelId);
            if (arr.length > 0) {
                e.chkListStatusId = arr[0].chkListStatusId;
                e.id = arr[0].id;
                e.createdBy = arr[0].createdBy;
                e.createdDate = arr[0].createdDate;
            }
            else
                e.chkListStatusId = '';

            e.bidPkgId = bidPackages[0].id;

            return e;
        });
    }

    if (locList.length === 0)
        return bidPkgCheckListStatusesLoc;
    else
        return locList;


}

function mapStateToProps(state) {
    return {
        bidPkgStatuses: state.projectsStore.bidPkgStatuses,
        bidPkgCheckListStatuses: state.projectsStore.bidPkgCheckListStatuses,
        selBidPkgCheckListStatuses: getSelBidPkgStatuses(state.projectsStore.bidPackages, state.projectsStore.bidPkgCheckListStatuses),
        bidPackages: state.projectsStore.bidPackages,
        permissionsModule: state.projectsStore.permissionsModule,
    }
}

export default connect(mapStateToProps, {
    fetchBidPackages,
    fetchBidPkgStatus,
    fetchBidCheckListStatus,
    fetchPermissionsByModule,
})(BidPackageNew);